import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import {
    Control,
    FieldErrors,
    UseFormRegister,
    UseFormReset,
    UseFormSetValue
} from "react-hook-form";
import 'react-quill/dist/quill.snow.css';
import { shallowEqual, useSelector } from "react-redux";
import WSButton from "../../Components/Button/WSButton";
import WSEditor from "../../Components/Editor/WSEditor";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { AppState } from "../../StateManagement/types";
interface EmailProps {
    control?: Control<any>;
    errors?: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    emailId?:string
    reset: UseFormReset<any>;
    setValue: UseFormSetValue<any>;
    onCancel: () => void;
    data?: any
    loading?:boolean
    onSubmitButtonClick?:(loading:boolean)=>void
}

export const EmailDrawyer: React.FC<EmailProps> = ({
    control,
    errors,
    register,
    id,
    reset,
    onCancel,
    data,
    setValue,
    loading,
    onSubmitButtonClick
}) => {
    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
    useEffect(() => {
        if (data) {
            setValue('toEmail', data?.toEmail);
            setValue('subject', data?.subject);
            setValue('body', data?.body);
            setValue('toEmail', data?.toEmail);
        }
    }, [data])

    const reduxComponentData = useSelector(
        (state: AppState) => state.components["emailSubmit"],
        shallowEqual 
      );
    
      // Local state to store Redux data
      const [componentData, setComponentData] = useState(reduxComponentData);
    
      // Update useState when Redux state changes
      useEffect(() => {
        if (reduxComponentData) {
          setComponentData(reduxComponentData);
        }
      }, [reduxComponentData]);
    return (
        <Grid >
            {<Grid item container spacing={2} mt={2}>
                <Grid item xs={12} sm={12}>
                    <WSTextField
                        label={"To"}
                        {...register("toEmail")}
                        id="toEmail"
                        disabled={data}
                        name="toEmail"
                        control={control}
                        rules={{ required: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <WSTextField
                        label={"Subject"}
                        {...register("subject")}
                        id="subject"
                        disabled={data}
                        name="subject"
                        control={control}
                        rules={{ required: true }}
                    />
                </Grid>
                <Grid item sm={12} xs={12}>
                    <WSEditor control={control}  {...register("body")} name="body" id="emailBody" label="Body" disabled={data} rules={{ required: true }} />
                </Grid>
                <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton disabled={data} loading={reduxComponentData?.data?.loading} className="ws-theme-crm" variant="outlined" id='emailSubmit' label={"Save"} type="submit" size="medium"  />
                    </Grid>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton disabled={data} id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                    </Grid>
                </Grid>
            </Grid>

            }
        </Grid>
    );
};
